// Known yacht model ranges per brand with typical LOA in meters.
// Used by the Add/Edit Yacht form: picking a brand preloads these models and
// picking a model prefills the (editable) length field.
export const YACHT_MODEL_CATALOG = {
  "Azimut": [
    { model: "Verve 42", length_m: 13.4, engines: 3, generators: 1 }, { model: "Atlantis 45", length_m: 14.6 },
    { model: "Fly 50", length_m: 15.4 }, { model: "S6", length_m: 18.1, engines: 3, generators: 1 },
    { model: "Fly 60", length_m: 18.4 }, { model: "Fly 68", length_m: 21.1 },
    { model: "S7", length_m: 21.1, engines: 3, generators: 1 }, { model: "Fly 72", length_m: 22.6 },
    { model: "Fly 78", length_m: 24.3 }, { model: "S8", length_m: 24.7, engines: 3, generators: 1 },
    { model: "Grande 26M", length_m: 26.4 }, { model: "Grande 27M", length_m: 27.2 },
    { model: "Grande 30M", length_m: 29.1 }, { model: "Grande 32M", length_m: 32.2 },
    { model: "Grande 36M", length_m: 35.7 },
  ],
  "Benetti": [
    { model: "Delfino 95", length_m: 28.95 }, { model: "Mediterraneo 116", length_m: 35.5 },
    { model: "Oasis 34M", length_m: 33.9 }, { model: "Oasis 40M", length_m: 40.8 },
    { model: "Diamond 145", length_m: 44.3 }, { model: "B.Yond 37M", length_m: 37.6 },
    { model: "B.Now 50M", length_m: 49.9 }, { model: "B.Now 60M", length_m: 59.9 },
  ],
  "Sunseeker": [
    { model: "Portofino 40", length_m: 12.3 }, { model: "Manhattan 55", length_m: 17.4 },
    { model: "Predator 55", length_m: 17.9 }, { model: "Manhattan 68", length_m: 21.3 },
    { model: "Predator 65", length_m: 20.4 }, { model: "76 Yacht", length_m: 23.9 },
    { model: "88 Yacht", length_m: 26.7 }, { model: "95 Yacht", length_m: 29.0 },
    { model: "100 Yacht", length_m: 30.9 }, { model: "131 Yacht", length_m: 40.05 },
  ],
  "Princess": [
    { model: "V40", length_m: 12.2 }, { model: "V50", length_m: 15.3 },
    { model: "F45", length_m: 14.6 }, { model: "F55", length_m: 17.4 },
    { model: "F65", length_m: 20.2 }, { model: "S66", length_m: 20.4 },
    { model: "V78", length_m: 24.1 }, { model: "Y80", length_m: 24.9 },
    { model: "Y95", length_m: 29.1 }, { model: "X95", length_m: 28.9 },
    { model: "30M", length_m: 30.4 }, { model: "40M", length_m: 40.2 },
  ],
  "Ferretti": [
    { model: "500", length_m: 15.3 }, { model: "580", length_m: 17.7 },
    { model: "670", length_m: 20.2 }, { model: "720", length_m: 22.3 },
    { model: "780", length_m: 24.0 }, { model: "860", length_m: 26.5 },
    { model: "920", length_m: 28.5 }, { model: "1000", length_m: 30.1 },
  ],
  "Pershing": [
    { model: "5X", length_m: 16.5 }, { model: "6X", length_m: 18.9 },
    { model: "7X", length_m: 21.1 }, { model: "8X", length_m: 25.5 },
    { model: "9X", length_m: 28.1 }, { model: "GTX116", length_m: 35.3, engines: 3 },
    { model: "140", length_m: 43.4, engines: 4, stabilizers: 3 },
  ],
  "Riva": [
    { model: "Aquariva Super", length_m: 10.1 }, { model: "Rivamare", length_m: 11.9 },
    { model: "Dolceriva", length_m: 14.7 }, { model: "66 Ribelle", length_m: 20.6 },
    { model: "76 Perseo Super", length_m: 23.3 }, { model: "88 Folgore", length_m: 26.8 },
    { model: "102 Corsaro Super", length_m: 31.3 }, { model: "130 Bellissima", length_m: 39.7 },
  ],
  "Sanlorenzo": [
    { model: "SL78", length_m: 24.5 }, { model: "SL86", length_m: 26.7 },
    { model: "SL96", length_m: 29.1 }, { model: "SL106", length_m: 32.6 },
    { model: "SX76", length_m: 23.4 }, { model: "SX88", length_m: 26.7 },
    { model: "SX112", length_m: 34.2 }, { model: "SD90", length_m: 27.4 },
    { model: "SD118", length_m: 35.8 }, { model: "500Exp", length_m: 47.0 },
  ],
  "Fairline": [
    { model: "F//Line 33", length_m: 10.3 }, { model: "Targa 45", length_m: 14.2 },
    { model: "Squadron 50", length_m: 15.6 }, { model: "Targa 58", length_m: 17.8 },
    { model: "Squadron 58", length_m: 17.8 }, { model: "Squadron 68", length_m: 21.4 },
    { model: "Phantom 65", length_m: 20.1 },
  ],
  "Galeon": [
    { model: "410 HTC", length_m: 12.9 }, { model: "440 Fly", length_m: 14.1 },
    { model: "500 Fly", length_m: 15.4 }, { model: "560 Fly", length_m: 17.6 },
    { model: "640 Fly", length_m: 20.4 }, { model: "680 Fly", length_m: 21.9 },
    { model: "800 Fly", length_m: 24.5 },
  ],
  "Prestige": [
    { model: "F4", length_m: 13.1 }, { model: "460", length_m: 14.5 },
    { model: "520", length_m: 16.2 }, { model: "590", length_m: 18.3 },
    { model: "690", length_m: 21.5 }, { model: "M48", length_m: 14.9 },
    { model: "X70", length_m: 21.7 },
  ],
  "Sea Ray": [
    { model: "Sundancer 265", length_m: 8.2, engines: 1 }, { model: "Sundancer 320", length_m: 10.2 },
    { model: "Sundancer 350", length_m: 10.9 }, { model: "Sundancer 370", length_m: 11.6 },
    { model: "SLX 400", length_m: 12.4 }, { model: "Fly 460", length_m: 14.6 },
  ],
  "Beneteau": [
    { model: "Oceanis 34.1", length_m: 10.8 }, { model: "Oceanis 40.1", length_m: 12.9 },
    { model: "Oceanis 46.1", length_m: 14.6 }, { model: "Oceanis 51.1", length_m: 15.9 },
    { model: "Oceanis Yacht 60", length_m: 18.2 }, { model: "Swift Trawler 41", length_m: 13.0 },
    { model: "Swift Trawler 48", length_m: 14.9 }, { model: "Grand Trawler 62", length_m: 19.0 },
  ],
  "Jeanneau": [
    { model: "Sun Odyssey 380", length_m: 11.2 }, { model: "Sun Odyssey 410", length_m: 12.4 },
    { model: "Sun Odyssey 440", length_m: 13.4 }, { model: "Sun Odyssey 490", length_m: 14.8 },
    { model: "Jeanneau Yachts 55", length_m: 17.3 }, { model: "Merry Fisher 1095", length_m: 10.5 },
    { model: "NC 37", length_m: 11.5 },
  ],
  "Lagoon": [
    { model: "40", length_m: 11.7 }, { model: "42", length_m: 12.8 },
    { model: "46", length_m: 13.99 }, { model: "51", length_m: 15.4 },
    { model: "55", length_m: 16.6 }, { model: "60", length_m: 18.3 },
    { model: "Sixty 5", length_m: 20.4 },
  ],
  "Bavaria": [
    { model: "C38", length_m: 11.4 }, { model: "C42", length_m: 12.4 },
    { model: "C46", length_m: 14.3 }, { model: "C50", length_m: 15.6 },
    { model: "SR41", length_m: 12.9, engines: 2, generators: 1 }, { model: "SR36", length_m: 11.6, engines: 2 },
  ],
  "Hanse": [
    { model: "348", length_m: 10.4 }, { model: "410", length_m: 12.4 },
    { model: "460", length_m: 14.6 }, { model: "510", length_m: 15.55 },
    { model: "548", length_m: 16.2 }, { model: "588", length_m: 17.8 },
  ],
  "Dufour": [
    { model: "37", length_m: 10.8 }, { model: "41", length_m: 12.4 },
    { model: "44", length_m: 13.3 }, { model: "470", length_m: 14.9 },
    { model: "530", length_m: 16.4 }, { model: "61", length_m: 18.8 },
  ],
  "Sirena Yachts": [
    { model: "Sirena 48", length_m: 15.1 }, { model: "Sirena 58", length_m: 17.9 },
    { model: "Sirena 68", length_m: 21.6 }, { model: "Sirena 78", length_m: 23.96 },
    { model: "Sirena 88", length_m: 26.7 },
  ],
  "Numarine": [
    { model: "22XP", length_m: 22.6 }, { model: "26XP", length_m: 26.4 },
    { model: "30XP", length_m: 30.4 }, { model: "32XP", length_m: 32.9 },
    { model: "37XP", length_m: 37.0 }, { model: "45XP", length_m: 45.0 },
  ],
  "Horizon": [
    { model: "FD75", length_m: 23.3 }, { model: "FD80", length_m: 24.7 },
    { model: "FD90", length_m: 27.6 }, { model: "FD100", length_m: 30.8 },
    { model: "E75", length_m: 23.5 }, { model: "E81", length_m: 25.4 },
  ],
  "Hatteras": [
    { model: "GT45X", length_m: 14.2 }, { model: "GT59", length_m: 18.4 },
    { model: "GT65 Carolina", length_m: 20.2 }, { model: "M75 Panacera", length_m: 23.2 },
    { model: "M90 Panacera", length_m: 28.0 },
  ],
  "Viking": [
    { model: "46 Billfish", length_m: 14.3 }, { model: "54 Convertible", length_m: 16.8 },
    { model: "58 Convertible", length_m: 18.1, generators: 2 }, { model: "64 Convertible", length_m: 19.9, generators: 2 },
    { model: "68 Convertible", length_m: 21.1 }, { model: "80 Convertible", length_m: 24.5 },
    { model: "90 Convertible", length_m: 28.0 },
  ],
  "Custom Line": [
    { model: "Navetta 30", length_m: 28.4 }, { model: "Navetta 33", length_m: 33.1 },
    { model: "Navetta 38", length_m: 37.8 }, { model: "Navetta 42", length_m: 41.8 },
    { model: "106", length_m: 32.8 }, { model: "120", length_m: 36.9 },
    { model: "140", length_m: 42.6 },
  ],
  "Mangusta": [
    { model: "Maxi Open 104 REV", length_m: 31.7 }, { model: "GranSport 33", length_m: 33.3 },
    { model: "GranSport 45", length_m: 45.0 }, { model: "Oceano 39", length_m: 38.8 },
    { model: "Oceano 44", length_m: 44.3 },
  ],
  "Monte Carlo Yachts": [
    { model: "MCY 66", length_m: 20.4 }, { model: "MCY 70", length_m: 21.4 },
    { model: "MCY 76", length_m: 23.1 }, { model: "MCY 80", length_m: 24.4 },
    { model: "MCY 96", length_m: 29.1 }, { model: "MCY 105", length_m: 31.9 },
  ],
  "Nordhavn": [
    { model: "N41", length_m: 12.6, engines: 2 }, { model: "N475", length_m: 14.9, engines: 1, stabilizers: 2 },
    { model: "N51", length_m: 15.9, engines: 1, stabilizers: 2 }, { model: "N60", length_m: 18.4, engines: 1, stabilizers: 2 },
    { model: "N71", length_m: 21.6, engines: 1, stabilizers: 2 }, { model: "N80", length_m: 24.5, engines: 1 },
  ],
  "Sunreef": [
    { model: "Sunreef 60", length_m: 18.3 }, { model: "Sunreef 70", length_m: 21.3 },
    { model: "Sunreef 80", length_m: 23.9 }, { model: "Supreme 68", length_m: 20.9 },
    { model: "100 Sunreef Power", length_m: 30.5, generators: 2 },
  ],
  "Fountaine Pajot": [
    { model: "Isla 40", length_m: 11.9 }, { model: "Elba 45", length_m: 13.4 },
    { model: "Aura 51", length_m: 15.5 }, { model: "Samana 59", length_m: 18.2 },
    { model: "MY5", length_m: 13.6 }, { model: "MY6", length_m: 18.3 },
  ],
  "Boston Whaler": [
    { model: "285 Conquest", length_m: 8.9 }, { model: "325 Conquest", length_m: 10.4 },
    { model: "350 Realm", length_m: 11.1 }, { model: "405 Conquest", length_m: 12.9, engines: 4 },
    { model: "420 Outrage", length_m: 13.2, engines: 4 },
  ],
  "Cranchi": [
    { model: "E30 Endurance", length_m: 9.2, engines: 1 }, { model: "A46 Luxury Tender", length_m: 14.2 },
    { model: "E52 F", length_m: 16.2 }, { model: "67 Sessantasette", length_m: 20.6 },
    { model: "78 Settantotto", length_m: 23.9 },
  ],
  "Maritimo": [
    { model: "M55", length_m: 17.6 }, { model: "M60", length_m: 19.6 },
    { model: "M75", length_m: 23.7 }, { model: "S55", length_m: 17.9 },
    { model: "S60", length_m: 19.5 }, { model: "S75", length_m: 23.8 },
  ],
  "Grand Banks": [
    { model: "GB54", length_m: 17.7 }, { model: "GB60", length_m: 20.2 },
    { model: "GB72", length_m: 23.4 }, { model: "GB85", length_m: 26.6 },
  ],
  "Leopard": [
    { model: "40", length_m: 11.99 }, { model: "42", length_m: 12.7 },
    { model: "45", length_m: 14.1 }, { model: "50", length_m: 15.4 },
    { model: "53 Powercat", length_m: 16.2 },
  ],
  "X-Yachts": [
    { model: "X4.0", length_m: 12.1 }, { model: "X4.3", length_m: 13.1 },
    { model: "X4.6", length_m: 14.2 }, { model: "X4.9", length_m: 15.0 },
    { model: "X5.6", length_m: 17.1 },
  ],
  "Hallberg-Rassy": [
    { model: "40C", length_m: 12.5 }, { model: "44", length_m: 13.9 },
    { model: "50", length_m: 15.5 }, { model: "57", length_m: 17.5 },
    { model: "69", length_m: 21.2 },
  ],
  "Nautor's Swan": [
    { model: "Swan 48", length_m: 14.8 }, { model: "Swan 55", length_m: 17.1 },
    { model: "Swan 58", length_m: 18.4 }, { model: "Swan 65", length_m: 20.1 },
    { model: "Swan 78", length_m: 24.0 }, { model: "Swan 88", length_m: 27.0 },
  ],
  "Wally": [
    { model: "wallytender43", length_m: 13.3 }, { model: "wallytender48", length_m: 14.9 },
    { model: "wallypower58", length_m: 17.8 }, { model: "wallywhy100", length_m: 21.6 },
    { model: "wallywhy150", length_m: 24.2 }, { model: "wallywhy200", length_m: 27.0 },
  ],
  "Wajer": [
    { model: "Wajer 38", length_m: 11.6 }, { model: "Wajer 44", length_m: 13.4 },
    { model: "Wajer 55", length_m: 16.7, engines: 3, generators: 1 }, { model: "Wajer 77", length_m: 23.4, engines: 3 },
  ],
  "Sealine": [
    { model: "S335", length_m: 10.4 }, { model: "C390", length_m: 11.9 },
    { model: "C430", length_m: 13.7 }, { model: "F430", length_m: 13.7 },
    { model: "C530", length_m: 16.3 },
  ],
  "Gulf Craft": [
    { model: "Majesty 62", length_m: 19.1 }, { model: "Majesty 72", length_m: 22.3 },
    { model: "Majesty 100", length_m: 31.7 }, { model: "Majesty 111", length_m: 34.0 },
    { model: "Majesty 120", length_m: 37.0 }, { model: "Nomad 70", length_m: 21.5 },
  ],
  "Dominator": [
    { model: "Ilumen 26M", length_m: 26.4 }, { model: "Ilumen 28M", length_m: 28.4 },
    { model: "Ilumen 32M", length_m: 32.3 },
  ],
  "Astondoa": [
    { model: "377 Coupé", length_m: 11.5 }, { model: "66 Flybridge", length_m: 20.9 },
    { model: "AS8", length_m: 25.3 }, { model: "100 Century", length_m: 30.5 },
  ],
  "Overmarine": [
    { model: "Mangusta 104 REV", length_m: 31.7 }, { model: "Mangusta GranSport 33", length_m: 33.3 },
    { model: "Mangusta Oceano 39", length_m: 38.8 },
  ],
};

// ── Typical machinery counts per model ─────────────────────────────────────
// Used to prefill the Engines / Generators / Stabilizers sections when a
// known model is picked (everything stays editable). Sailing yachts get a
// single engine and no stabilizers; catamarans twin engines; motoryachts
// scale generators/stabilizers with length.
const SAIL_BRANDS = new Set([
  "Hanse", "Dufour", "X-Yachts", "Hallberg-Rassy", "Nautor's Swan",
  "Bavaria", "Elan", "Catalina", "Hunter",
]);
const CAT_BRANDS = new Set(["Lagoon", "Leopard", "Sunreef", "Fountaine Pajot"]);
const SAIL_MODEL_PREFIXES = ["Oceanis", "Sun Odyssey", "Jeanneau Yachts", "Swan", "X4", "X5"];

export function defaultSpecCounts(brand, model, lengthM) {
  const len = Number(lengthM) || 0;
  // Per-model overrides in the catalog win (e.g. triple-IPS Azimut S-series).
  const entry = (YACHT_MODEL_CATALOG[brand] || []).find((m) => m.model === model) || {};
  const isSail = SAIL_BRANDS.has(brand)
    || SAIL_MODEL_PREFIXES.some((p) => (model || "").startsWith(p));
  let base;
  if (isSail) {
    base = { engines: 1, generators: len >= 15 ? 1 : 0, stabilizers: 0 };
  } else if (CAT_BRANDS.has(brand)) {
    base = { engines: 2, generators: 1, stabilizers: 0 };
  } else {
    base = {
      engines: 2,
      generators: len >= 20 ? 2 : len >= 12 ? 1 : 0,
      stabilizers: len >= 24 ? 2 : len >= 14 ? 1 : 0,
    };
  }
  return {
    engines: entry.engines ?? base.engines,
    generators: entry.generators ?? base.generators,
    stabilizers: entry.stabilizers ?? base.stabilizers,
  };
}

// ── Factory-typical engines ────────────────────────────────────────────────
// Per-model exact packages where the standard powertrain is well known;
// otherwise the brand's usual engine make is suggested (type/power left to
// the user, whose Type dropdown then shows that brand's catalog with kW).
// All values are HINTS — every field stays editable.
export const DEFAULT_ENGINE_BRAND = {
  "Azimut": "MAN", "Benetti": "MAN", "Sunseeker": "MAN", "Princess": "MAN",
  "Ferretti": "MAN", "Pershing": "MTU", "Riva": "MTU", "Sanlorenzo": "MTU",
  "Custom Line": "MTU", "Mangusta": "MTU", "Overmarine": "MTU", "Viking": "MTU",
  "Fairline": "Volvo Penta", "Galeon": "Volvo Penta", "Prestige": "Volvo Penta",
  "Sea Ray": "MerCruiser", "Beneteau": "Yanmar", "Jeanneau": "Yanmar",
  "Lagoon": "Yanmar", "Leopard": "Yanmar", "X-Yachts": "Yanmar",
  "Bavaria": "Volvo Penta", "Hanse": "Volvo Penta", "Dufour": "Volvo Penta",
  "Hallberg-Rassy": "Volvo Penta", "Nautor's Swan": "Volvo Penta",
  "Sunreef": "Volvo Penta", "Fountaine Pajot": "Volvo Penta",
  "Boston Whaler": "Mercury Marine", "Cranchi": "Volvo Penta",
  "Maritimo": "Scania", "Grand Banks": "Volvo Penta", "Wally": "Volvo Penta",
  "Wajer": "Volvo Penta", "Sealine": "Volvo Penta", "Sirena Yachts": "Caterpillar",
  "Numarine": "MAN", "Horizon": "MAN", "Hatteras": "Caterpillar",
  "Monte Carlo Yachts": "MAN", "Nordhavn": "John Deere", "Gulf Craft": "MAN",
  "Dominator": "MAN", "Astondoa": "MAN",
};

// Exact factory-standard packages (per engine) for popular models.
const MODEL_ENGINES = {
  "Azimut|Verve 42": { brand: "Mercury Marine", type: "Verado 400", kw: 298 },
  "Azimut|Atlantis 45": { brand: "Volvo Penta", type: "IPS600", kw: 320 },
  "Azimut|Fly 50": { brand: "Volvo Penta", type: "IPS950", kw: 533 },
  "Azimut|S6": { brand: "Volvo Penta", type: "IPS700", kw: 405 },
  "Azimut|Fly 60": { brand: "Volvo Penta", type: "IPS950", kw: 533 },
  "Azimut|S7": { brand: "Volvo Penta", type: "IPS1050", kw: 588 },
  "Azimut|S8": { brand: "Volvo Penta", type: "IPS1350", kw: 735 },
  "Azimut|Fly 68": { brand: "MAN", type: "V12-1400", kw: 1029 },
  "Azimut|Fly 72": { brand: "MAN", type: "V12-1550", kw: 1140 },
  "Azimut|Fly 78": { brand: "MAN", type: "V12-1800", kw: 1324 },
  "Azimut|Grande 26M": { brand: "MAN", type: "V12-1550", kw: 1140 },
  "Azimut|Grande 27M": { brand: "MAN", type: "V12-1900", kw: 1397 },
  "Azimut|Grande 32M": { brand: "MAN", type: "V12-2000", kw: 1471 },
  "Sunseeker|Manhattan 55": { brand: "Volvo Penta", type: "IPS950", kw: 533 },
  "Sunseeker|Manhattan 68": { brand: "MAN", type: "V12-1400", kw: 1029 },
  "Sunseeker|Predator 65": { brand: "MAN", type: "V12-1400", kw: 1029 },
  "Sunseeker|76 Yacht": { brand: "MAN", type: "V12-1550", kw: 1140 },
  "Sunseeker|88 Yacht": { brand: "MAN", type: "V12-1900", kw: 1397 },
  "Sunseeker|95 Yacht": { brand: "MTU", type: "10V2000M96L", kw: 1193 },
  "Princess|V50": { brand: "Volvo Penta", type: "IPS950", kw: 533 },
  "Princess|F55": { brand: "MAN", type: "i6-800", kw: 588 },
  "Princess|F65": { brand: "MAN", type: "V8-1300", kw: 956 },
  "Princess|S66": { brand: "MAN", type: "V8-1300", kw: 956 },
  "Princess|V78": { brand: "MAN", type: "V12-1800", kw: 1324 },
  "Princess|Y80": { brand: "MAN", type: "V12-1900", kw: 1397 },
  "Princess|X95": { brand: "MAN", type: "V12-1650", kw: 1213 },
  "Ferretti|500": { brand: "Cummins", type: "QSC8.3", kw: 447 },
  "Ferretti|670": { brand: "MAN", type: "V8-1300", kw: 956 },
  "Ferretti|720": { brand: "MAN", type: "V12-1400", kw: 1029 },
  "Ferretti|780": { brand: "MAN", type: "V12-1550", kw: 1140 },
  "Ferretti|860": { brand: "MTU", type: "10V2000M86", kw: 1104 },
  "Ferretti|1000": { brand: "MTU", type: "16V2000M96L", kw: 1948 },
  "Pershing|5X": { brand: "Volvo Penta", type: "IPS1050", kw: 588 },
  "Pershing|6X": { brand: "MAN", type: "V12-1550", kw: 1140 },
  "Pershing|7X": { brand: "MAN", type: "V12-1800", kw: 1324 },
  "Pershing|8X": { brand: "MTU", type: "16V2000M96L", kw: 1948 },
  "Pershing|9X": { brand: "MTU", type: "16V2000M96L", kw: 1948 },
  "Pershing|GTX116": { brand: "MAN", type: "V12-1800", kw: 1324 },
  "Pershing|140": { brand: "MTU", type: "16V2000M96L", kw: 1939 },
  "Riva|Rivamare": { brand: "Volvo Penta", type: "D6-400", kw: 294 },
  "Riva|Dolceriva": { brand: "Volvo Penta", type: "D8-600", kw: 441 },
  "Riva|66 Ribelle": { brand: "MAN", type: "V12-1550", kw: 1140 },
  "Riva|76 Perseo Super": { brand: "MAN", type: "V12-1800", kw: 1324 },
  "Riva|88 Folgore": { brand: "MTU", type: "16V2000M96L", kw: 1948 },
  "Sanlorenzo|SL78": { brand: "MTU", type: "10V2000M86", kw: 1104 },
  "Sanlorenzo|SL86": { brand: "MTU", type: "12V2000M86", kw: 1324 },
  "Sanlorenzo|SL96": { brand: "MTU", type: "16V2000M86", kw: 1790 },
  "Fairline|Targa 45": { brand: "Volvo Penta", type: "IPS650", kw: 353 },
  "Fairline|Squadron 68": { brand: "MAN", type: "V12-1400", kw: 1029 },
  "Galeon|440 Fly": { brand: "Volvo Penta", type: "IPS600", kw: 320 },
  "Galeon|500 Fly": { brand: "Volvo Penta", type: "IPS950", kw: 533 },
  "Galeon|640 Fly": { brand: "Volvo Penta", type: "IPS1350", kw: 735 },
  "Prestige|460": { brand: "Volvo Penta", type: "IPS600", kw: 320 },
  "Prestige|520": { brand: "Volvo Penta", type: "IPS700", kw: 405 },
  "Prestige|590": { brand: "Volvo Penta", type: "IPS950", kw: 533 },
  "Prestige|690": { brand: "Volvo Penta", type: "IPS1200", kw: 662 },
  "Lagoon|40": { brand: "Yanmar", type: "4JH45", kw: 33 },
  "Lagoon|42": { brand: "Yanmar", type: "4JH57", kw: 42 },
  "Lagoon|46": { brand: "Yanmar", type: "4JH57", kw: 42 },
  "Lagoon|51": { brand: "Yanmar", type: "4JH80", kw: 59 },
  "Lagoon|55": { brand: "Yanmar", type: "4LV115", kw: 85 },
  "Beneteau|Oceanis 40.1": { brand: "Yanmar", type: "4JH45", kw: 33 },
  "Beneteau|Oceanis 46.1": { brand: "Yanmar", type: "4JH57", kw: 42 },
  "Beneteau|Oceanis 51.1": { brand: "Yanmar", type: "4JH80", kw: 59 },
  "Beneteau|Swift Trawler 41": { brand: "Volvo Penta", type: "D4-300", kw: 221 },
  "Beneteau|Swift Trawler 48": { brand: "Volvo Penta", type: "D6-340", kw: 250 },
  "Jeanneau|Sun Odyssey 410": { brand: "Yanmar", type: "4JH45", kw: 33 },
  "Jeanneau|Sun Odyssey 440": { brand: "Yanmar", type: "4JH45", kw: 33 },
  "Jeanneau|Sun Odyssey 490": { brand: "Yanmar", type: "4JH57", kw: 42 },
  "Hanse|460": { brand: "Volvo Penta", type: "D2-50", kw: 37 },
  "Hanse|510": { brand: "Volvo Penta", type: "D2-75", kw: 55 },
  "Fountaine Pajot|Isla 40": { brand: "Volvo Penta", type: "D1-30", kw: 21 },
  "Fountaine Pajot|Elba 45": { brand: "Volvo Penta", type: "D2-50", kw: 37 },
  "Fountaine Pajot|Aura 51": { brand: "Volvo Penta", type: "D2-60", kw: 44 },
  "Sirena Yachts|Sirena 58": { brand: "Caterpillar", type: "C8.7", kw: 405 },
  "Sirena Yachts|Sirena 68": { brand: "Caterpillar", type: "C12.9", kw: 735 },
  "Sirena Yachts|Sirena 88": { brand: "Caterpillar", type: "C18", kw: 875 },
  "Maritimo|M55": { brand: "Volvo Penta", type: "D13-900", kw: 662 },
  "Maritimo|M60": { brand: "Volvo Penta", type: "D13-1000", kw: 735 },
  "Maritimo|M75": { brand: "Scania", type: "DI16 072M", kw: 846 },
  "Nordhavn|N41": { brand: "John Deere", type: "4045AFM85", kw: 90 },
  "Nordhavn|N51": { brand: "John Deere", type: "4045AFM85", kw: 90 },
  "Nordhavn|N60": { brand: "John Deere", type: "6068AFM85", kw: 158 },
  "Wajer|Wajer 44": { brand: "Volvo Penta", type: "IPS650", kw: 353 },
  "Wajer|Wajer 55": { brand: "Volvo Penta", type: "IPS600", kw: 320 },
  "Wajer|Wajer 77": { brand: "Volvo Penta", type: "IPS1350", kw: 735 },
  "Monte Carlo Yachts|MCY 66": { brand: "MAN", type: "V8-1300", kw: 956 },
  "Monte Carlo Yachts|MCY 76": { brand: "MAN", type: "V12-1400", kw: 1029 },
  "Monte Carlo Yachts|MCY 96": { brand: "MAN", type: "V12-1900", kw: 1397 },
  "Numarine|22XP": { brand: "MAN", type: "i6-800", kw: 588 },
  "Numarine|26XP": { brand: "MAN", type: "i6-800", kw: 588 },
  "Numarine|32XP": { brand: "MAN", type: "V8-1300", kw: 956 },
  "Cranchi|E52 F": { brand: "Volvo Penta", type: "IPS700", kw: 405 },
  "Cranchi|67 Sessantasette": { brand: "Volvo Penta", type: "IPS1050", kw: 588 },
  "Grand Banks|GB54": { brand: "Volvo Penta", type: "IPS950", kw: 533 },
  "Grand Banks|GB60": { brand: "Volvo Penta", type: "IPS1050", kw: 588 },
  "Viking|64 Convertible": { brand: "MTU", type: "12V2000M96L", kw: 1432 },
  "Viking|68 Convertible": { brand: "MTU", type: "12V2000M96L", kw: 1432 },
  "Viking|80 Convertible": { brand: "MTU", type: "16V2000M96L", kw: 1948 },
  "Hatteras|GT59": { brand: "Caterpillar", type: "C18", kw: 875 },
  "Hatteras|GT65 Carolina": { brand: "Caterpillar", type: "C32", kw: 1417 },
  "Sea Ray|Sundancer 320": { brand: "MerCruiser", type: "6.2L V8", kw: 261 },
  "Sea Ray|Sundancer 370": { brand: "Volvo Penta", type: "D6-380", kw: 279 },
  "Boston Whaler|325 Conquest": { brand: "Mercury Marine", type: "Verado 300", kw: 224 },
  "Boston Whaler|405 Conquest": { brand: "Mercury Marine", type: "Verado 400", kw: 298 },
  "Boston Whaler|420 Outrage": { brand: "Mercury Marine", type: "Verado 400", kw: 298 },
  "Sea Ray|Sundancer 265": { brand: "MerCruiser", type: "6.2L V8", kw: 261 },
  "Bavaria|SR41": { brand: "Volvo Penta", type: "D6-400", kw: 294 },
  "Cranchi|E30 Endurance": { brand: "Volvo Penta", type: "V8-350", kw: 257 },
  "Nordhavn|N475": { brand: "John Deere", type: "4045AFM85", kw: 90 },
};

export function typicalEngine(brand, model) {
  const exact = MODEL_ENGINES[`${brand}|${model}`];
  if (exact) return exact;
  const eb = DEFAULT_ENGINE_BRAND[brand];
  return eb ? { brand: eb } : null;
}

// ── Tenders ────────────────────────────────────────────────────────────────
// Common tender/RIB brands and their known models with typical LOA and the
// factory-standard engine (prefilled into the tender's engines list, group
// "Tenders"). All hints — fully editable.
export const TENDER_BRANDS = [
  "AB Inflatables", "Avon", "Brig", "Castoldi", "Highfield", "Novurania",
  "Pascoe International", "Ribeye", "Sacs", "Williams", "Zar Formenti", "Zodiac",
];

export const TENDER_MODEL_CATALOG = {
  "Williams": [
    { model: "Turbojet 285", length_m: 2.85, engine: { brand: "Textron", type: "MPE 850", kw: 73 } },
    { model: "Sportjet 345", length_m: 3.45, engine: { brand: "Rotax", type: "900 ACE", kw: 67 } },
    { model: "Sportjet 395", length_m: 3.95, engine: { brand: "Rotax", type: "1630 ACE 115", kw: 86 } },
    { model: "Sportjet 435", length_m: 4.35, engine: { brand: "Rotax", type: "1630 ACE 150", kw: 112 } },
    { model: "Sportjet 460", length_m: 4.6, engine: { brand: "Rotax", type: "1630 ACE 170", kw: 127 } },
    { model: "Dieseljet 445", length_m: 4.45, engine: { brand: "Yanmar", type: "4JH4-HTE", kw: 81 } },
    { model: "Dieseljet 505", length_m: 5.05, engine: { brand: "Yanmar", type: "4LV150", kw: 110 } },
    { model: "Dieseljet 565", length_m: 5.65, engine: { brand: "Yanmar", type: "4LV195", kw: 143 } },
    { model: "Evojet 70", length_m: 7.0, engine: { brand: "Yanmar", type: "8LV-370", kw: 272 } },
  ],
  "Zodiac": [
    { model: "Open 5.5", length_m: 5.5, engine: { brand: "Yamaha", type: "F100", kw: 74 } },
    { model: "Medline 5.8", length_m: 5.8, engine: { brand: "Yamaha", type: "F115", kw: 86 } },
    { model: "Medline 6.8", length_m: 6.8, engine: { brand: "Yamaha", type: "F200", kw: 147 } },
    { model: "Medline 7.5", length_m: 7.5, engine: { brand: "Yamaha", type: "F250", kw: 184 } },
  ],
  "Highfield": [
    { model: "Sport 460", length_m: 4.6, engine: { brand: "Honda", type: "BF60", kw: 44 } },
    { model: "Sport 560", length_m: 5.6, engine: { brand: "Honda", type: "BF115", kw: 86 } },
    { model: "Sport 660", length_m: 6.6, engine: { brand: "Honda", type: "BF150", kw: 110 } },
  ],
  "AB Inflatables": [
    { model: "Oceanus 12 VST", length_m: 3.66, engine: { brand: "Yamaha", type: "F60", kw: 44 } },
    { model: "Oceanus 14 VST", length_m: 4.27, engine: { brand: "Yamaha", type: "F100", kw: 74 } },
    { model: "Oceanus 15 VST", length_m: 4.57, engine: { brand: "Yamaha", type: "F115", kw: 86 } },
  ],
  "Novurania": [
    { model: "Chase 23", length_m: 7.0, engine: { brand: "Volvo Penta", type: "V8-350", kw: 257 } },
    { model: "Chase 27", length_m: 8.2, engine: { brand: "Volvo Penta", type: "V8-430", kw: 316 } },
    { model: "Equator 24", length_m: 7.3, engine: { brand: "Yanmar", type: "8LV-320", kw: 235 } },
  ],
  "Castoldi": [
    { model: "Jet Tender 14", length_m: 4.28, engine: { brand: "Yanmar", type: "4JH4-HTE", kw: 81 } },
    { model: "Jet Tender 16", length_m: 4.87, engine: { brand: "Yanmar", type: "4LV170", kw: 125 } },
    { model: "Jet Tender 18", length_m: 5.55, engine: { brand: "Yanmar", type: "4LV230", kw: 169 } },
    { model: "Jet Tender 21", length_m: 6.35, engine: { brand: "Yanmar", type: "6LY440", kw: 324 } },
  ],
  "Brig": [
    { model: "Eagle 5", length_m: 5.0, engine: { brand: "Yamaha", type: "F100", kw: 74 } },
    { model: "Eagle 6.7", length_m: 6.7, engine: { brand: "Yamaha", type: "F200", kw: 147 } },
    { model: "Eagle 8", length_m: 7.95, engine: { brand: "Yamaha", type: "F300", kw: 221, engines: 2 } },
    { model: "Eagle 10", length_m: 9.9, engine: { brand: "Yamaha", type: "F300", kw: 221, engines: 2 } },
  ],
  "Ribeye": [
    { model: "A600", length_m: 6.0, engine: { brand: "Yamaha", type: "F130", kw: 96 } },
    { model: "TS750", length_m: 7.5, engine: { brand: "Yamaha", type: "F250", kw: 184 } },
  ],
  "Sacs": [
    { model: "Strider 700", length_m: 7.1, engine: { brand: "Mercury Marine", type: "Verado 250", kw: 186 } },
  ],
  "Zar Formenti": [
    { model: "59 SL", length_m: 5.9, engine: { brand: "Yamaha", type: "F115", kw: 86 } },
    { model: "79 SL", length_m: 7.5, engine: { brand: "Yamaha", type: "F250", kw: 184 } },
  ],
  "Pascoe International": [
    { model: "SL460", length_m: 4.6, engine: { brand: "Yanmar", type: "4LV150", kw: 110 } },
    { model: "SL560", length_m: 5.6, engine: { brand: "Yanmar", type: "4LV250", kw: 184 } },
  ],
  "Avon": [
    { model: "Seasport 440", length_m: 4.4, engine: { brand: "Yamaha", type: "F60", kw: 44 } },
    { model: "Seasport 490", length_m: 4.9, engine: { brand: "Yamaha", type: "F90", kw: 66 } },
  ],
};
